import { Route, Routes } from 'react-router-dom';
import { PagePaths } from './lib/pagePaths';
import { Home } from './pages/Home';
import { Resume } from './pages/Resume';
import { Portfolio } from './pages/Portfolio';
import { Inquiries } from './pages/Inquiries';
import { Logo } from './pages/Logo';
import { TestingArea } from './pages/TestingArea';
import { NotFound } from './pages/NotFound';

const { paths } = PagePaths;

export function AppRoutes() {
  return (
    <Routes>
      <Route path={`/${paths.home}`} element={<Home />} />
      <Route path={`/${paths.resume}`} element={<Resume />} />
      <Route path={`/${paths.portfolio}`} element={<Portfolio />} />
      <Route path={`/${paths.inquiries}`} element={<Inquiries />} />
      <Route path={`/${paths.logo}`} element={<Logo />} />
      <Route path={`/${paths.testingEnvironment}`} element={<TestingArea />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
